/** @file tileBindings: the Tile screen's key table (context `tile`, on only while a Tile tab shows). */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

/** `when: tileScreen` is evaluated by `installShortcuts`; the `tile` context is pushed while the screen is mounted. */
const t = (id: string, keys: string): Binding => ({ id, keys, context: 'tile', when: 'tileScreen' });

/**
 * Tools B pencil, E eraser, G bucket, I eyedropper, L line; M Mirror X, O onion, Shift+G pixel grid; 0 zoom to fit,
 * = and - zoom; local undo Mod+Z, redo Mod+Shift+Z and Mod+Y (the tab's strokes, not the server's Undo); Mod+S Save;
 * Alt+W closes the tab (browsers never deliver Ctrl+W to a page). Ctrl+V is the page's paste event, not a binding.
 */
export const tileBindings: Binding[] = [
  t('tile.pencil', 'KeyB'), t('tile.eraser', 'KeyE'), t('tile.bucket', 'KeyG'), t('tile.eyedropper', 'KeyI'), t('tile.line', 'KeyL'),
  t('tile.mirror', 'KeyM'), t('tile.onion', 'KeyO'), t('tile.grid', 'Shift+KeyG'),
  t('tile.zoomFit', 'Digit0'), t('tile.zoomIn', 'Equal'), t('tile.zoomOut', 'Minus'),
  t('tile.undo', 'Mod+KeyZ'), t('tile.redo', 'Mod+Shift+KeyZ'), t('tile.redoAlt', 'Mod+KeyY'),
  t('tile.save', 'Mod+KeyS'), t('tile.close', 'Alt+KeyW'),
];
